import type { ReactNode } from 'react'
import { type MarketingLocale, MarketingLocaleProvider } from '~/lib/marketing-locale'
import { LanguageBanner } from './language-banner'
import { MarketingFooter } from './marketing-footer'
import { MarketingNav } from './marketing-nav'
import '~/styles/marketing.css'

/** Shared chrome (nav + footer) for any marketing page beyond the home.
 *
 * Owns the locale provider, so a page only has to declare which language it
 * is and every nested component — nav, footer, product mockups — follows. */
export const MarketingShell = ({
  children,
  locale = 'pt-BR',
}: {
  children: ReactNode
  locale?: MarketingLocale
}) => (
  <MarketingLocaleProvider locale={locale}>
    <div className="mkt-site min-h-screen bg-white font-sans text-[#0b0b0d] antialiased [text-rendering:optimizeLegibility]">
      <LanguageBanner />
      <MarketingNav />
      <main className="pt-[72px]">{children}</main>
      <MarketingFooter />
    </div>
  </MarketingLocaleProvider>
)
